import { Store } from "utils";
import StandStore from "./standstore";
import RatioStore from "./ratiostore";

class SelectedPavilionStore extends Store {
  getInitialState() {
    return {
      selected: null,
      slugs: [],
      stand: null,
      map: null,
      ready: false,
    };
  }

  onSelectedPavilionChanged(state, data) {
    state.selected = data;

    if (data.stands.length > 0) {
      state.activeStand = data.stands[0];
    }

    var before = null;
    var sm = [];
    var mp = {};

    var first = true;

    let typeGroups = data.stands.reduce((res, stand) => {
      let typeCount = stand.standType.standFeatureCount;
      if (!res.hasOwnProperty(typeCount)) res[typeCount] = [];
      res[typeCount].push(stand);
      return res;
    }, {});

    let final = [];
    Object.keys(typeGroups)
      .sort((a, b) => b - a)
      .forEach((key) => {
        final.push(...this.shuffleArray(typeGroups[key]));
      });
    data.stands = final;

    data.stands.forEach(function(item) {
      mp[item.slug] = item;

      var links = {
        before: null,
        slug: item.slug,
        after: null,
      };

      if (before != null) {
        before.after = item.slug;
        links.before = before.slug;
      }

      before = links;
      sm[item.slug] = links;

      if (first) {
        mp["first"] = item;
        sm["first"] = links;

        first = false;
      }
    });

    state.slugs = sm;
    state.map = mp;
    state.ready = true;

    $(window).trigger("resize");
  }

  /**
   * Shuffles array in place. ES6 version
   * @param {Array} a items An array containing the items.
   */
  shuffleArray(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  onSelectedStandChanged(state, data) {
    state.stand = data.slug;
  }

  getSelectedStand() {
    var state = this.getState();
    var slug = state.stand;

    if (state.map) {
      var stand = state.map[slug];
      if (stand) {
        return stand.title;
      }
    }

    return null;
  }

  getRatio() {
    return RatioStore.getRatio();
  }

  getStands() {
    var selected = this.getState().selected;
    if (selected) {
      return selected.stands;
    } else {
      return [];
    }
  }

  getSelectedStandSlug() {
    return this.getState().stand;
  }

  onLoadingSelectedPavilion(state) {
    state.selected = null;
  }

  getSelectedPavilion() {
    return this.getState().selected;
  }

  getStand(slug) {
    var mp = this.getState().map;

    if (mp != null) {
      return mp[slug];
    } else {
      return null;
    }
  }

  /**
   * @deprecated
   */
  getStandId(slug) {
    return StandStore.findStandId(slug);
  }

  getSelectedPavilionSlug() {
    var selected = this.getState().selected;

    if (selected) {
      return selected.slug;
    } else {
      return null;
    }
  }

  isActive(stand) {
    var state = this.getState();
    if (state.ready) {
      var selected = state.stand;
      var st = state.slugs[selected];

      if (st) {
        var active =
          stand == st.before || stand == st.slug || stand == st.after;
        return active;
      }
    }

    return false;
  }

  isReady() {
    return this.getState().ready;
  }
}

const store = new SelectedPavilionStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/SelectedPavilionStore.js